import IMAdjustmentList from './IMAdjustmentList';
export default IMAdjustmentList;
